import { $intent, $intents } from './constants';
export function isIntent(intent) {
    return intent == null ? false : !!intent[$intent];
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const intentRegistry = new Map();
export function createIntentType(label, config) {
    const symbol = Symbol(label);
    function decorate(obj) {
        const intent = obj;
        Object.defineProperty(intent, $intent, {
            value: symbol,
            enumerable: false,
            writable: false
        });
        return intent;
    }
    const create = config.create;
    const intentType = create ? create(decorate) : decorate;
    intentType.add = config.add;
    intentType.merge = config.merge;
    intentType.symbol = symbol;
    intentType.isIntent = (intent)=>intent == null ? false : intent[$intent] === symbol;
    intentRegistry.set(symbol, intentType);
    return intentType;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toIntentType = createIntentType('toIntent', {
    add () {
        return null;
    },
    merge () {
        return null;
    }
});
export function toIntent(intents) {
    return toIntentType(intents);
}
// eslint-disable-next-line @typescript-eslint/ban-types
export function createIntentMap(value, source) {
    const obj = value;
    var _source_$intents;
    // TODO(koop): Make this lazy; this will save a bunch of memory
    obj[$intents] = (_source_$intents = source === null || source === void 0 ? void 0 : source[$intents]) !== null && _source_$intents !== void 0 ? _source_$intents : new Map();
    return obj;
}
export function getIntents(type, obj) {
    const intents = obj[$intents];
    return intents ? intents.get(type.symbol) : undefined;
}
export function deleteIntents(type, obj) {
    const intents = obj[$intents];
    if (intents) {
        intents.delete(type.symbol);
    }
}
export function forEachIntent(intents, callback) {
    for(let i = 0; i < intents.length; i++){
        const intent = intents[i];
        if (toIntentType.isIntent(intent)) {
            forEachIntent(intent, callback);
        } else if (intent) {
            callback(intent);
        }
    }
}
export function addIntent(obj, intent) {
    if (toIntentType.isIntent(intent)) {
        forEachIntent(intent, (intent)=>addIntent(obj, intent));
        return;
    }
    const intents = obj[$intents];
    const intentSymbol = intent[$intent];
    const intentType = intentRegistry.get(intentSymbol);
    if (intentType) {
        const state = intents.get(intentSymbol);
        const result = intentType.add(intent, state);
        if (state !== result) {
            intents.set(intentSymbol, result);
        }
    }
}
export function mergeIntents(target, source, // eslint-disable-next-line @typescript-eslint/no-explicit-any
shouldMergeIntentType) {
    const targetIntents = target[$intents];
    const sourceIntents = source[$intents];
    const intentTypes = Array.from(sourceIntents.keys());
    for(let i = 0; i < intentTypes.length; i++){
        const key = intentTypes[i];
        const intentType = intentRegistry.get(key);
        if (intentType && (shouldMergeIntentType ? shouldMergeIntentType(intentType) : true)) {
            const targetState = targetIntents.get(key);
            const sourceState = sourceIntents.get(key);
            const result = intentType.merge(targetState, sourceState);
            if (targetState !== result) {
                targetIntents.set(key, result);
            }
        }
    }
}

//# sourceMappingURL=intent.js.map